import apiCall from "./apiCall";
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  async create_fuel_category(data) {
    let response = await apiCall("fuel_categories/create", data);
    return response;
  },
  async list_fuel_categories(data) {
    let response = await apiCall("fuel_categories/list_fuel_categories", data);
    return response;
  },
  async update_fuel_category(data) {
    let response = await apiCall(
      "fuel_categories/update_fuel_station_group",
      data
    );
    return response;
  },
};
